import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '../services/i18n.service';

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
  private i18n = inject(I18nService);
  transform(values: any, _field: string): any[] {
    return values
      .map((v: any) => ({ label: this.i18n.parse(v), value: v }))
      .sort((a: any, b: any) => a['label'].localeCompare(b['label']));
  }
}
